import { useEffect, useRef } from 'react';

import useNoInternet from 'utils/hooks/useNoInternet';

type Params = {
    playerVisible: boolean;
    onNoInternet(): void;
    onIntertnetBack(): void;
};

function useNoInternetConnection({
    playerVisible,
    onNoInternet,
    onIntertnetBack,
}: Params) {
    const { isInternetConnected } = useNoInternet();
    const prevIsInternetConnected = useRef(isInternetConnected);

    useEffect(() => {
        if (playerVisible) {
            if (
                prevIsInternetConnected.current &&
                isInternetConnected === false
            ) {
                onNoInternet();
            }
            if (
                prevIsInternetConnected.current === false &&
                isInternetConnected
            ) {
                onIntertnetBack();
            }

            prevIsInternetConnected.current = isInternetConnected;
        }
    }, [onNoInternet, isInternetConnected, playerVisible]);
}

export default useNoInternetConnection;
